import { Back, Power0, TweenMax } from 'gsap';
import { GameAudio } from '../Config/Audio';
import { getGameSize } from '../Config/Levels';
import Core from '../Core/Core';
import SoundManager from '../Sound/SoundManager';
import SpeechBox from '../UI/Shared/SpeechBox';
import { waitForMs } from '../Utils/AsyncUtils';
import GameLoader from '../Core/Assets';

export default class TutorialView extends PIXI.Container {
    public ferret: PIXI.Sprite;
    public textBox: SpeechBox;
    public initialized: boolean = false;
    private inPosition: PIXI.Point;
    private outPosition: PIXI.Point;
    private leftOutPosition: PIXI.Point;
    private leftInPosition: PIXI.Point;
    private bottomOutPosition: PIXI.Point;
    private bottomInPosition: PIXI.Point;
    private textXOffset: number;
    private textYOffset: number;

    constructor() {
        super();

        // this.initTutorial();
    }

    public async initTutorial() {
        await GameLoader.loadAssetList({ assetList: ['tutorial'] });

        this.ferret = new PIXI.Sprite(PIXI.utils.TextureCache['tutorial/tutorial-character']);

        this.leftInPosition = new PIXI.Point();
        this.leftInPosition.x = this.ferret.height * 0.8;
        this.leftInPosition.y = getGameSize().gameHeight * 0.7 - this.ferret.height * 0.5;

        this.bottomInPosition = new PIXI.Point();
        this.bottomInPosition.x = getGameSize().gameWidth * 0.25 - this.ferret.width * 0.5;
        this.bottomInPosition.y = getGameSize().gameHeight - this.ferret.height * 0.8;

        this.leftOutPosition = new PIXI.Point();
        this.leftOutPosition.x = -this.ferret.height;
        this.leftOutPosition.y = getGameSize().gameHeight * 0.7 - this.ferret.height * 0.5;

        this.bottomOutPosition = new PIXI.Point();
        this.bottomOutPosition.x = getGameSize().gameWidth * 0.25 - this.ferret.width * 0.5;
        this.bottomOutPosition.y = getGameSize().gameHeight + this.ferret.height;

        this.ferret = null;

        this.interactive = true;
        this.initialized = true;
    }

    // txt position
    public showStep(side: number, txt: string, animate: boolean) {
        this.inPosition = side === 4 ? this.leftInPosition : this.bottomInPosition;
        this.outPosition = side === 4 ? this.leftOutPosition : this.bottomOutPosition;
        this.textXOffset = side === 3 ? 160 : 75;
        this.textYOffset = side === 4 ? 85 : 0;

        if (side === 0) {
            return;
        }

        if (!this.ferret) {
            this.showCharacter(side);
        }

        if (!this.textBox) {
            this.showTextBox().catch(() => {});
        }

        if (animate && this.textBox) {
            TweenMax.to(this.textBox.scale, 0.2, {
                ease: Power0.easeOut,
                onComplete: () => {
                    if (txt !== '' && this.textBox) {
                        this.textBox.showTxt(Core.local.getText(txt));
                    }
                    if (this.textBox) {
                        TweenMax.to(this.textBox.scale, 0.2, {
                            ease: Power0.easeIn,
                            x: 1.1,
                            y: 1.1,
                        });
                    }
                },
                x: 0.8,
                y: 0.8,
            });
        } else {
            if (txt !== '' && this.textBox) {
                this.textBox.showTxt(Core.local.getText(txt));
            }
        }
    }

    public showCharacter(side: number) {
        if (!this.ferret) {
            this.ferret = new PIXI.Sprite(PIXI.utils.TextureCache['tutorial/tutorial-character']);
            this.addChild(this.ferret);
        }

        this.ferret.rotation = side === 4 ? 90 * (Math.PI / 180) : 0;
        this.ferret.position.set(this.outPosition.x, this.outPosition.y);
        SoundManager.playSound(GameAudio.WHOOSH_IN);
        TweenMax.to(this.ferret, 0.9, {
            x: this.inPosition.x,
            y: this.inPosition.y,
            ease: Back.easeOut,
            onComplete: this.showTextBox.bind(this),
        });
    }

    public async showTextBox() {
        if (!this.textBox) {
            this.textBox = new SpeechBox();
            this.textBox.x = this.inPosition.x + this.textXOffset * 2.1;
            this.textBox.y = this.inPosition.y - this.textBox.bg.height * 0.35 + this.textYOffset;
            this.textBox.alpha = 0;
            this.textBox.scale.set(1.1);
            this.addChild(this.textBox);
            TweenMax.to(this.textBox, 0.5, { alpha: 1, delay: 0.4 });

            await waitForMs(800);
        }
    }

    public dismissBox() {
        if (!this.textBox) {
            return;
        }
        const t = this.textBox;
        this.textBox = null;
        TweenMax.to(t, 0.3, {
            alpha: 0,
            onComplete: () => {
                t.destroy();
            },
        });
    }

    public dismissCharacter() {
        if (!this.ferret) {
            return;
        }
        const f = this.ferret;
        this.ferret = null;
        SoundManager.playSound(GameAudio.WHOOSH_OUT);
        TweenMax.to(f, 0.9, {
            x: this.outPosition.x,
            y: this.outPosition.y,
            ease: Back.easeIn,
            onComplete: () => {
                f.destroy();
            },
        });
    }

    public update() {}

    public cleanUp() {}
}
